import React from 'react';
import { Style } from './types';
import VgsShowValue from './VgsShowValue';
import VgsCollectValue from './VgsCollectValue';
import { FieldError } from './field';

export default function VgsInput({
  name,
  value,
  label,
  type,
  replacePatterns,
  onRevealSuccess,
  onRevealFail,
  validations,
  maskInput,
  placeholder,
  style,
  inputClass,
  required,
  showRequiredAsterisk,
  onEmptyChange,
  onInvalidChange,
  onDirtyChange,
  form,
  serializers,
  fieldErrors,
  token,
}: {
  name: string;
  label: string;
  validations?: RegExp[];
  maskInput?: MaskInput;
  placeholder?: string;
  type: VgsFieldType;
  style?: Style;
  required: boolean;
  showRequiredAsterisk: boolean;
  serializers?: VgsSerializer[];
  onDirtyChange?: (fieldName: string, isDirty: boolean) => void;
  onEmptyChange: (fieldName: string, isEmpty: boolean) => void;
  onInvalidChange: (fieldName: string, isValid: boolean) => void;
  form: VGSForm<unknown>;
  inputClass?: string;
  value?: string | null;
  replacePatterns?: [string, string, number?][];
  onRevealSuccess?: () => void;
  onRevealFail?: () => void;
  fieldErrors?: FieldError[];
  token: string;
}): React.JSX.Element {
  if (typeof value === 'string') {
    return (
      <VgsShowValue
        value={value}
        label={label}
        type={type}
        replacePatterns={replacePatterns}
        onRevealSuccess={onRevealSuccess}
        onRevealFail={onRevealFail}
        useFieldStyling={true}
        token={token}
      />
    );
  } else {
    return (
      <VgsCollectValue
        name={name}
        label={label}
        type={type}
        validations={validations}
        maskInput={maskInput}
        placeholder={placeholder}
        style={style}
        inputClass={inputClass}
        required={required}
        showRequiredAsterisk={showRequiredAsterisk}
        onEmptyChange={onEmptyChange}
        onInvalidChange={onInvalidChange}
        onDirtyChange={onDirtyChange}
        form={form}
        serializers={serializers}
        fieldErrors={fieldErrors}
      />
    );
  }
}
